const SUB_PAGES = {
  CLIENT_PANEL: 'CLIENT_PANEL',
  DIET_SUBPAGE: 'DIET_SUBPAGE',
  DIET_FLOW_STATISTICS: 'DIET_FLOW_STATISTICS',
  TIME_SLOTS_SUBPAGE: 'TIME_SLOTS_SUBPAGE',
};

export default SUB_PAGES;
